import React from 'react';
import { RefundManagementComponent } from '../../index';

const Mobile = (props) => {
    return <RefundManagementComponent {...props} />;
};

export default Mobile;
